/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as SilentRenewImport } from './routes/silent-renew'
import { Route as CallbackImport } from './routes/callback'
import { Route as AuthLoginImport } from './routes/auth/login'
import { Route as appErrorImport } from './routes/(app)/error'
import { Route as appLayoutImport } from './routes/(app)/_layout'
import { Route as appLayoutIndexImport } from './routes/(app)/_layout/index'
import { Route as appLayoutSummaryImport } from './routes/(app)/_layout/summary'
import { Route as appLayoutReportImport } from './routes/(app)/_layout/report'
import { Route as appLayoutProfileImport } from './routes/(app)/_layout/profile'
import { Route as appLayoutManageTasksImport } from './routes/(app)/_layout/manage-tasks'
import { Route as appLayoutKeyDeadlineImport } from './routes/(app)/_layout/key-deadline'
import { Route as appLayoutImportImport } from './routes/(app)/_layout/import'
import { Route as appLayoutGlobalSummaryImport } from './routes/(app)/_layout/global-summary'
import { Route as appLayoutUsersIndexImport } from './routes/(app)/_layout/users/index'
import { Route as appLayoutTasksIndexImport } from './routes/(app)/_layout/tasks/index'
import { Route as appLayoutUsersCreateImport } from './routes/(app)/_layout/users/create'
import { Route as appLayoutUsersEmailImport } from './routes/(app)/_layout/users/$email'
import { Route as appLayoutTasksCreateImport } from './routes/(app)/_layout/tasks/create'
import { Route as appLayoutTasksIdImport } from './routes/(app)/_layout/tasks/$id'

// Create Virtual Routes

const appImport = createFileRoute('/(app)')()

// Create/Update Routes

const appRoute = appImport.update({
  id: '/(app)',
  getParentRoute: () => rootRoute,
} as any)

const SilentRenewRoute = SilentRenewImport.update({
  id: '/silent-renew',
  path: '/silent-renew',
  getParentRoute: () => rootRoute,
} as any)

const CallbackRoute = CallbackImport.update({
  id: '/callback',
  path: '/callback',
  getParentRoute: () => rootRoute,
} as any)

const AuthLoginRoute = AuthLoginImport.update({
  id: '/auth/login',
  path: '/auth/login',
  getParentRoute: () => rootRoute,
} as any)

const appErrorRoute = appErrorImport.update({
  id: '/error',
  path: '/error',
  getParentRoute: () => appRoute,
} as any)

const appLayoutRoute = appLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => appRoute,
} as any)

const appLayoutIndexRoute = appLayoutIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => appLayoutRoute,
} as any)

const appLayoutSummaryRoute = appLayoutSummaryImport.update({
  id: '/summary',
  path: '/summary',
  getParentRoute: () => appLayoutRoute,
} as any)

const appLayoutReportRoute = appLayoutReportImport.update({
  id: '/report',
  path: '/report',
  getParentRoute: () => appLayoutRoute,
} as any)

const appLayoutProfileRoute = appLayoutProfileImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => appLayoutRoute,
} as any)

const appLayoutManageTasksRoute = appLayoutManageTasksImport.update({
  id: '/manage-tasks',
  path: '/manage-tasks',
  getParentRoute: () => appLayoutRoute,
} as any)

const appLayoutKeyDeadlineRoute = appLayoutKeyDeadlineImport.update({
  id: '/key-deadline',
  path: '/key-deadline',
  getParentRoute: () => appLayoutRoute,
} as any)

const appLayoutImportRoute = appLayoutImportImport.update({
  id: '/import',
  path: '/import',
  getParentRoute: () => appLayoutRoute,
} as any)

const appLayoutGlobalSummaryRoute = appLayoutGlobalSummaryImport.update({
  id: '/global-summary',
  path: '/global-summary',
  getParentRoute: () => appLayoutRoute,
} as any)

const appLayoutUsersIndexRoute = appLayoutUsersIndexImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => appLayoutRoute,
} as any)

const appLayoutTasksIndexRoute = appLayoutTasksIndexImport.update({
  id: '/tasks/',
  path: '/tasks/',
  getParentRoute: () => appLayoutRoute,
} as any)

const appLayoutUsersCreateRoute = appLayoutUsersCreateImport.update({
  id: '/users/create',
  path: '/users/create',
  getParentRoute: () => appLayoutRoute,
} as any)

const appLayoutUsersEmailRoute = appLayoutUsersEmailImport.update({
  id: '/users/$email',
  path: '/users/$email',
  getParentRoute: () => appLayoutRoute,
} as any)

const appLayoutTasksCreateRoute = appLayoutTasksCreateImport.update({
  id: '/tasks/create',
  path: '/tasks/create',
  getParentRoute: () => appLayoutRoute,
} as any)

const appLayoutTasksIdRoute = appLayoutTasksIdImport.update({
  id: '/tasks/$id',
  path: '/tasks/$id',
  getParentRoute: () => appLayoutRoute,
} as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/callback': {
      id: '/callback'
      path: '/callback'
      fullPath: '/callback'
      preLoaderRoute: typeof CallbackImport
      parentRoute: typeof rootRoute
    }
    '/silent-renew': {
      id: '/silent-renew'
      path: '/silent-renew'
      fullPath: '/silent-renew'
      preLoaderRoute: typeof SilentRenewImport
      parentRoute: typeof rootRoute
    }
    '/(app)': {
      id: '/(app)'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof appImport
      parentRoute: typeof rootRoute
    }
    '/(app)/_layout': {
      id: '/(app)/_layout'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof appLayoutImport
      parentRoute: typeof appRoute
    }
    '/(app)/error': {
      id: '/(app)/error'
      path: '/error'
      fullPath: '/error'
      preLoaderRoute: typeof appErrorImport
      parentRoute: typeof appImport
    }
    '/auth/login': {
      id: '/auth/login'
      path: '/auth/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof AuthLoginImport
      parentRoute: typeof rootRoute
    }
    '/(app)/_layout/global-summary': {
      id: '/(app)/_layout/global-summary'
      path: '/global-summary'
      fullPath: '/global-summary'
      preLoaderRoute: typeof appLayoutGlobalSummaryImport
      parentRoute: typeof appLayoutImport
    }
    '/(app)/_layout/import': {
      id: '/(app)/_layout/import'
      path: '/import'
      fullPath: '/import'
      preLoaderRoute: typeof appLayoutImportImport
      parentRoute: typeof appLayoutImport
    }
    '/(app)/_layout/key-deadline': {
      id: '/(app)/_layout/key-deadline'
      path: '/key-deadline'
      fullPath: '/key-deadline'
      preLoaderRoute: typeof appLayoutKeyDeadlineImport
      parentRoute: typeof appLayoutImport
    }
    '/(app)/_layout/manage-tasks': {
      id: '/(app)/_layout/manage-tasks'
      path: '/manage-tasks'
      fullPath: '/manage-tasks'
      preLoaderRoute: typeof appLayoutManageTasksImport
      parentRoute: typeof appLayoutImport
    }
    '/(app)/_layout/profile': {
      id: '/(app)/_layout/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof appLayoutProfileImport
      parentRoute: typeof appLayoutImport
    }
    '/(app)/_layout/report': {
      id: '/(app)/_layout/report'
      path: '/report'
      fullPath: '/report'
      preLoaderRoute: typeof appLayoutReportImport
      parentRoute: typeof appLayoutImport
    }
    '/(app)/_layout/summary': {
      id: '/(app)/_layout/summary'
      path: '/summary'
      fullPath: '/summary'
      preLoaderRoute: typeof appLayoutSummaryImport
      parentRoute: typeof appLayoutImport
    }
    '/(app)/_layout/': {
      id: '/(app)/_layout/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof appLayoutIndexImport
      parentRoute: typeof appLayoutImport
    }
    '/(app)/_layout/tasks/$id': {
      id: '/(app)/_layout/tasks/$id'
      path: '/tasks/$id'
      fullPath: '/tasks/$id'
      preLoaderRoute: typeof appLayoutTasksIdImport
      parentRoute: typeof appLayoutImport
    }
    '/(app)/_layout/tasks/create': {
      id: '/(app)/_layout/tasks/create'
      path: '/tasks/create'
      fullPath: '/tasks/create'
      preLoaderRoute: typeof appLayoutTasksCreateImport
      parentRoute: typeof appLayoutImport
    }
    '/(app)/_layout/users/$email': {
      id: '/(app)/_layout/users/$email'
      path: '/users/$email'
      fullPath: '/users/$email'
      preLoaderRoute: typeof appLayoutUsersEmailImport
      parentRoute: typeof appLayoutImport
    }
    '/(app)/_layout/users/create': {
      id: '/(app)/_layout/users/create'
      path: '/users/create'
      fullPath: '/users/create'
      preLoaderRoute: typeof appLayoutUsersCreateImport
      parentRoute: typeof appLayoutImport
    }
    '/(app)/_layout/tasks/': {
      id: '/(app)/_layout/tasks/'
      path: '/tasks'
      fullPath: '/tasks'
      preLoaderRoute: typeof appLayoutTasksIndexImport
      parentRoute: typeof appLayoutImport
    }
    '/(app)/_layout/users/': {
      id: '/(app)/_layout/users/'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof appLayoutUsersIndexImport
      parentRoute: typeof appLayoutImport
    }
  }
}

// Create and export the route tree

interface appLayoutRouteChildren {
  appLayoutGlobalSummaryRoute: typeof appLayoutGlobalSummaryRoute
  appLayoutImportRoute: typeof appLayoutImportRoute
  appLayoutKeyDeadlineRoute: typeof appLayoutKeyDeadlineRoute
  appLayoutManageTasksRoute: typeof appLayoutManageTasksRoute
  appLayoutProfileRoute: typeof appLayoutProfileRoute
  appLayoutReportRoute: typeof appLayoutReportRoute
  appLayoutSummaryRoute: typeof appLayoutSummaryRoute
  appLayoutIndexRoute: typeof appLayoutIndexRoute
  appLayoutTasksIdRoute: typeof appLayoutTasksIdRoute
  appLayoutTasksCreateRoute: typeof appLayoutTasksCreateRoute
  appLayoutUsersEmailRoute: typeof appLayoutUsersEmailRoute
  appLayoutUsersCreateRoute: typeof appLayoutUsersCreateRoute
  appLayoutTasksIndexRoute: typeof appLayoutTasksIndexRoute
  appLayoutUsersIndexRoute: typeof appLayoutUsersIndexRoute
}

const appLayoutRouteChildren: appLayoutRouteChildren = {
  appLayoutGlobalSummaryRoute: appLayoutGlobalSummaryRoute,
  appLayoutImportRoute: appLayoutImportRoute,
  appLayoutKeyDeadlineRoute: appLayoutKeyDeadlineRoute,
  appLayoutManageTasksRoute: appLayoutManageTasksRoute,
  appLayoutProfileRoute: appLayoutProfileRoute,
  appLayoutReportRoute: appLayoutReportRoute,
  appLayoutSummaryRoute: appLayoutSummaryRoute,
  appLayoutIndexRoute: appLayoutIndexRoute,
  appLayoutTasksIdRoute: appLayoutTasksIdRoute,
  appLayoutTasksCreateRoute: appLayoutTasksCreateRoute,
  appLayoutUsersEmailRoute: appLayoutUsersEmailRoute,
  appLayoutUsersCreateRoute: appLayoutUsersCreateRoute,
  appLayoutTasksIndexRoute: appLayoutTasksIndexRoute,
  appLayoutUsersIndexRoute: appLayoutUsersIndexRoute,
}

const appLayoutRouteWithChildren = appLayoutRoute._addFileChildren(
  appLayoutRouteChildren,
)

interface appRouteChildren {
  appLayoutRoute: typeof appLayoutRouteWithChildren
  appErrorRoute: typeof appErrorRoute
}

const appRouteChildren: appRouteChildren = {
  appLayoutRoute: appLayoutRouteWithChildren,
  appErrorRoute: appErrorRoute,
}

const appRouteWithChildren = appRoute._addFileChildren(appRouteChildren)

export interface FileRoutesByFullPath {
  '/callback': typeof CallbackRoute
  '/silent-renew': typeof SilentRenewRoute
  '/': typeof appLayoutIndexRoute
  '/error': typeof appErrorRoute
  '/auth/login': typeof AuthLoginRoute
  '/global-summary': typeof appLayoutGlobalSummaryRoute
  '/import': typeof appLayoutImportRoute
  '/key-deadline': typeof appLayoutKeyDeadlineRoute
  '/manage-tasks': typeof appLayoutManageTasksRoute
  '/profile': typeof appLayoutProfileRoute
  '/report': typeof appLayoutReportRoute
  '/summary': typeof appLayoutSummaryRoute
  '/tasks/$id': typeof appLayoutTasksIdRoute
  '/tasks/create': typeof appLayoutTasksCreateRoute
  '/users/$email': typeof appLayoutUsersEmailRoute
  '/users/create': typeof appLayoutUsersCreateRoute
  '/tasks': typeof appLayoutTasksIndexRoute
  '/users': typeof appLayoutUsersIndexRoute
}

export interface FileRoutesByTo {
  '/callback': typeof CallbackRoute
  '/silent-renew': typeof SilentRenewRoute
  '/error': typeof appErrorRoute
  '/auth/login': typeof AuthLoginRoute
  '/global-summary': typeof appLayoutGlobalSummaryRoute
  '/import': typeof appLayoutImportRoute
  '/key-deadline': typeof appLayoutKeyDeadlineRoute
  '/manage-tasks': typeof appLayoutManageTasksRoute
  '/profile': typeof appLayoutProfileRoute
  '/report': typeof appLayoutReportRoute
  '/summary': typeof appLayoutSummaryRoute
  '/': typeof appLayoutIndexRoute
  '/tasks/$id': typeof appLayoutTasksIdRoute
  '/tasks/create': typeof appLayoutTasksCreateRoute
  '/users/$email': typeof appLayoutUsersEmailRoute
  '/users/create': typeof appLayoutUsersCreateRoute
  '/tasks': typeof appLayoutTasksIndexRoute
  '/users': typeof appLayoutUsersIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/callback': typeof CallbackRoute
  '/silent-renew': typeof SilentRenewRoute
  '/(app)': typeof appRouteWithChildren
  '/(app)/_layout': typeof appLayoutRouteWithChildren
  '/(app)/error': typeof appErrorRoute
  '/auth/login': typeof AuthLoginRoute
  '/(app)/_layout/global-summary': typeof appLayoutGlobalSummaryRoute
  '/(app)/_layout/import': typeof appLayoutImportRoute
  '/(app)/_layout/key-deadline': typeof appLayoutKeyDeadlineRoute
  '/(app)/_layout/manage-tasks': typeof appLayoutManageTasksRoute
  '/(app)/_layout/profile': typeof appLayoutProfileRoute
  '/(app)/_layout/report': typeof appLayoutReportRoute
  '/(app)/_layout/summary': typeof appLayoutSummaryRoute
  '/(app)/_layout/': typeof appLayoutIndexRoute
  '/(app)/_layout/tasks/$id': typeof appLayoutTasksIdRoute
  '/(app)/_layout/tasks/create': typeof appLayoutTasksCreateRoute
  '/(app)/_layout/users/$email': typeof appLayoutUsersEmailRoute
  '/(app)/_layout/users/create': typeof appLayoutUsersCreateRoute
  '/(app)/_layout/tasks/': typeof appLayoutTasksIndexRoute
  '/(app)/_layout/users/': typeof appLayoutUsersIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/callback'
    | '/silent-renew'
    | '/'
    | '/error'
    | '/auth/login'
    | '/global-summary'
    | '/import'
    | '/key-deadline'
    | '/manage-tasks'
    | '/profile'
    | '/report'
    | '/summary'
    | '/tasks/$id'
    | '/tasks/create'
    | '/users/$email'
    | '/users/create'
    | '/tasks'
    | '/users'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/callback'
    | '/silent-renew'
    | '/error'
    | '/auth/login'
    | '/global-summary'
    | '/import'
    | '/key-deadline'
    | '/manage-tasks'
    | '/profile'
    | '/report'
    | '/summary'
    | '/'
    | '/tasks/$id'
    | '/tasks/create'
    | '/users/$email'
    | '/users/create'
    | '/tasks'
    | '/users'
  id:
    | '__root__'
    | '/callback'
    | '/silent-renew'
    | '/(app)'
    | '/(app)/_layout'
    | '/(app)/error'
    | '/auth/login'
    | '/(app)/_layout/global-summary'
    | '/(app)/_layout/import'
    | '/(app)/_layout/key-deadline'
    | '/(app)/_layout/manage-tasks'
    | '/(app)/_layout/profile'
    | '/(app)/_layout/report'
    | '/(app)/_layout/summary'
    | '/(app)/_layout/'
    | '/(app)/_layout/tasks/$id'
    | '/(app)/_layout/tasks/create'
    | '/(app)/_layout/users/$email'
    | '/(app)/_layout/users/create'
    | '/(app)/_layout/tasks/'
    | '/(app)/_layout/users/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  CallbackRoute: typeof CallbackRoute
  SilentRenewRoute: typeof SilentRenewRoute
  appRoute: typeof appRouteWithChildren
  AuthLoginRoute: typeof AuthLoginRoute
}

const rootRouteChildren: RootRouteChildren = {
  CallbackRoute: CallbackRoute,
  SilentRenewRoute: SilentRenewRoute,
  appRoute: appRouteWithChildren,
  AuthLoginRoute: AuthLoginRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/callback",
        "/silent-renew",
        "/(app)",
        "/auth/login"
      ]
    },
    "/callback": {
      "filePath": "callback.tsx"
    },
    "/silent-renew": {
      "filePath": "silent-renew.tsx"
    },
    "/(app)": {
      "filePath": "(app)",
      "children": [
        "/(app)/_layout",
        "/(app)/error"
      ]
    },
    "/(app)/_layout": {
      "filePath": "(app)/_layout.tsx",
      "parent": "/(app)",
      "children": [
        "/(app)/_layout/global-summary",
        "/(app)/_layout/import",
        "/(app)/_layout/key-deadline",
        "/(app)/_layout/manage-tasks",
        "/(app)/_layout/profile",
        "/(app)/_layout/report",
        "/(app)/_layout/summary",
        "/(app)/_layout/",
        "/(app)/_layout/tasks/$id",
        "/(app)/_layout/tasks/create",
        "/(app)/_layout/users/$email",
        "/(app)/_layout/users/create",
        "/(app)/_layout/tasks/",
        "/(app)/_layout/users/"
      ]
    },
    "/(app)/error": {
      "filePath": "(app)/error.tsx",
      "parent": "/(app)"
    },
    "/auth/login": {
      "filePath": "auth/login.tsx"
    },
    "/(app)/_layout/global-summary": {
      "filePath": "(app)/_layout/global-summary.tsx",
      "parent": "/(app)/_layout"
    },
    "/(app)/_layout/import": {
      "filePath": "(app)/_layout/import.tsx",
      "parent": "/(app)/_layout"
    },
    "/(app)/_layout/key-deadline": {
      "filePath": "(app)/_layout/key-deadline.tsx",
      "parent": "/(app)/_layout"
    },
    "/(app)/_layout/manage-tasks": {
      "filePath": "(app)/_layout/manage-tasks.tsx",
      "parent": "/(app)/_layout"
    },
    "/(app)/_layout/profile": {
      "filePath": "(app)/_layout/profile.tsx",
      "parent": "/(app)/_layout"
    },
    "/(app)/_layout/report": {
      "filePath": "(app)/_layout/report.tsx",
      "parent": "/(app)/_layout"
    },
    "/(app)/_layout/summary": {
      "filePath": "(app)/_layout/summary.tsx",
      "parent": "/(app)/_layout"
    },
    "/(app)/_layout/": {
      "filePath": "(app)/_layout/index.tsx",
      "parent": "/(app)/_layout"
    },
    "/(app)/_layout/tasks/$id": {
      "filePath": "(app)/_layout/tasks/$id.tsx",
      "parent": "/(app)/_layout"
    },
    "/(app)/_layout/tasks/create": {
      "filePath": "(app)/_layout/tasks/create.tsx",
      "parent": "/(app)/_layout"
    },
    "/(app)/_layout/users/$email": {
      "filePath": "(app)/_layout/users/$email.tsx",
      "parent": "/(app)/_layout"
    },
    "/(app)/_layout/users/create": {
      "filePath": "(app)/_layout/users/create.tsx",
      "parent": "/(app)/_layout"
    },
    "/(app)/_layout/tasks/": {
      "filePath": "(app)/_layout/tasks/index.tsx",
      "parent": "/(app)/_layout"
    },
    "/(app)/_layout/users/": {
      "filePath": "(app)/_layout/users/index.tsx",
      "parent": "/(app)/_layout"
    }
  }
}
ROUTE_MANIFEST_END */
